import IBroker from "@/module/main/model/applicationForm/IBroker";

export default class Broker implements IBroker
{
    constructor(public merchantName: string = "",
                public merchantUrl: string = "",
                public merchantBusinessId: string = "",
                public merchantNumber: string = "",
                public merchantReservationDate: Date | null = null)
    {
    }
}
